/** A second in ms */
export const Second = 1000;

/** A minute in ms */
export const Minute = 60 * Second;

/** An hour in ms */
export const Hour = 60 * Minute;

/** A day in ms */
export const Day = 24 * Hour;
